import { Routes } from '@angular/router';
import { AuthCallBackComponent } from '../components/auth-call-back/auth-call-back.component';

export const oktaRoutes: Routes = [{ path: 'implicit/callback', component: AuthCallBackComponent }];
